export const INFORMATION = "information";
export const EWAIVER = "ewaiver";
export const FINISH = "finish";
export const REGULATIONS = "regulations";

export const EWAIVER_RUNNER = "ewaiver-of-runner";
